module.exports = __webpack_public_path__ + "static/media/local.schema.7af95752.graphql";